import { createGlobalStyle } from "styled-components"
import { theme } from "../theme/theme"

export const HomeStyle = createGlobalStyle`
  .main {
    width: 100%;
    margin: 0 auto;
    padding: 120px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${theme.color.background};
    padding-bottom: 100px;

    .main_form {
      width: 55%;
      //
      //h1 {
      //  font-size: 55px;
      //  line-height: 55px;
      //  margin-bottom: 20px;
      //  max-width: 600px;
      //
      //  @media (max-width: 1200px) {
      //    font-size: 45px;
      //    line-height: 45px;
      //  }
      //
      //  @media (max-width: 600px) {
      //    font-size: 40px;
      //    line-height: 50px;
      //  }
      //}
      //
      //p {
      //  max-width: 800px;
      //}

      .main_form_wrapper {
        margin: 40px 0;
        margin-bottom: 0px;

        .top_belt {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-gap: 10px;

          @media (max-width: 800px) {
            grid-template-columns: 1fr;

            .radio_wrapper {
              width: 100%;
              max-width: none;
            }
          }
        }

        .main_form_content {
          width: 100%;
          grid-gap: 1px;
          margin-top: 15px;
          display: grid;
          grid-template-columns: 4fr 6fr;
          box-shadow: ${theme.variable.boxShadow};
          border-radius: ${theme.variable.borderRadius};
          background: ${theme.color.fourth};

          > div:first-of-type {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 1px;

            > div {

              &:first-of-type {
                border-radius: ${theme.variable.borderRadius} 0 0 ${theme.variable.borderRadius};
              }
            }

            @media (max-width: 1300px) and (min-width: 1200px) {
              > div {
                &:first-of-type {
                  border-radius: ${theme.variable.borderRadius} 0 0 0;
                }

                &:last-of-type {
                  border-radius: 0 ${theme.variable.borderRadius} 0 0;
                }
              }
            }

            @media (max-width: 900px) and (min-width: 601px) {
              > div {
                &:first-of-type {
                  border-radius: ${theme.variable.borderRadius} 0 0 0;
                }

                &:last-of-type {
                  border-radius: 0 ${theme.variable.borderRadius} 0 0;
                }
              }
            }
            @media (max-width: 600px) {
              > div {
                &:first-of-type {
                  border-radius: ${theme.variable.borderRadius} ${theme.variable.borderRadius} 0 0;
                }
              }
            }
          }

          > div:last-of-type {
            display: grid;
            grid-template-columns: auto 70px;
            grid-gap: 1px;

            > div {
              &:last-of-type {
                border-radius: 0 ${theme.variable.borderRadius} ${theme.variable.borderRadius} 0;
              }
            }

            @media (max-width: 1300px) and (min-width: 1200px) {
              grid-template-columns: 1fr;

              > div {
                &:first-of-type {
                  border-radius: 0 0 0 ${theme.variable.borderRadius};
                }

                &:last-of-type {
                  border-radius: 0 0 ${theme.variable.borderRadius} 0;
                }
              }
            }

            @media (max-width: 900px) {
              grid-template-columns: 1fr;
            }

            @media (max-width: 600px) {
              > div {
                &:last-of-type {
                  border-radius: 0 0 ${theme.variable.borderRadius} ${theme.variable.borderRadius};
                }
              }
            }
          }

          > div {
            min-height: 70px;
          }

          .filters {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            min-height: 71px;

            button {
              display: flex;
              justify-content: center;
              align-items: center;
              background: none;
              border: none;
              font-size: ${({ theme }) => theme.font.M};
              font-weight: ${({ theme }) => theme.font.normal};
              height: max-content;
              cursor: pointer;

              svg {
                height: ${({ theme }) => theme.font.XXL};
              }

              label {
                display: none;
              }

              @media (max-width: 600px) {
                svg {
                  height: ${({ theme }) => theme.font.XL};
                }

                label {
                  display: inline-block;
                  margin-left: 20px;
                }
              }
            }
          }

          .search {
            padding: 5px;
            min-height: 70px;
          }

          .price_range {
            min-width: 200px;
            min-height: 70px;
            position: relative;
            display: flex;
            align-items: center;
          }

          @media (max-width: 1300px) and (min-width: 1200px) {
            grid-template-columns: 1fr;
          }
          @media (max-width: 900px) {
            grid-template-columns: 1fr;
          }
          @media (max-width: 600px) {
            > div {
              grid-template-columns: 1fr !important;
            }
          }
        }

        .main_form_footer {
          width: 100%;
          grid-gap: 1px;
          margin-top: 1px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          box-shadow: ${theme.variable.boxShadow};
          border-radius: ${theme.variable.borderRadius};
          background: ${theme.color.fourth};
          
          > div {
            padding: 5px;
            min-height: 70px;
          }

          @media (max-width: 1300px) and (min-width: 1200px) {
            grid-template-columns: 1fr;
          }
          @media (max-width: 900px) {
            grid-template-columns: 1fr;
          }
          @media (max-width: 600px) {
            > div {
              grid-template-columns: 1fr !important;
            }
          }
        }
      }

      @media (max-width: 1600px) {
        width: 60%;
      }
    }

    .main_slider {
      width: 40%;
      background: ${theme.color.primary};
      border-radius: 25px;
      height: 33vw;
      max-width: 33vw;
      margin: 0;
      
      @media (max-width: 1600px) {
        width: 35%;
        min-height: 33vw;
        max-width: 33vw;
      }
      
      @media (max-width: 1200px){
        display: none;
      }
    } 

    @media (max-width: 1200px) {
      display: block;
      > div {
        width: 100% !important;
      }
    }
  }

  .filters {
    .filters_grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-row-gap: 30px;
      grid-column-gap: 30px;

      @media (max-width: 600px) {
        grid-template-columns: 1fr;
        > div {
          grid-column-end: auto !important;
        }
      }
    }

    .filter-submit {
      position: sticky;
      bottom: 0px;
    }
  }

  .offers {
    margin: 0px auto;
    padding: 40px 0;
    width: 90%;

    .offers_grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      margin: 0 auto;
      margin-top: 30px;
      grid-gap: 20px;
      max-width: 1200px;

      @media (max-width: 1200px) {
        grid-template-columns: 1fr 1fr;
      }
      @media (max-width: 700px) {
        grid-template-columns: 1fr;
      }
    }
  }
`
